var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { isNil, isEmpty } from "ramda";
var Input = forwardRef(function (props, ref) {
    var error = props.error, _a = props.className, className = _a === void 0 ? "" : _a, id = props.id, forward = __rest(props, ["error", "className", "id"]);
    var inputErrorId = id + "-error-msg";
    var hasError = !isNil(error) && !isEmpty(error);
    var errorClass = "";
    var renderedError;
    if (hasError) {
        errorClass = "error";
        renderedError = (React.createElement("span", { className: "error-text", id: inputErrorId }, error));
    }
    return (React.createElement("span", { className: "text-input " + errorClass },
        React.createElement("input", __assign({}, forward, (hasError ? { "aria-describedby": inputErrorId } : {}), { className: cn("text", className, errorClass), id: id, ref: ref })),
        renderedError));
});
export default Input;
